import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import ProposalItemSlice from "./Slice/ProposalItemSlice";
import ProposalSummeryDataSlice from "./Slice/SummeryDataSlice";

const store = configureStore({
  reducer: {
    proposalItems: ProposalItemSlice.reducer,
    proposalSummary: ProposalSummeryDataSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
